import { render } from "./xtx-button.vue?vue&type=template&id=a4b8c170&scoped=true"
import script from "./xtx-button.vue?vue&type=script&lang=js"
export * from "./xtx-button.vue?vue&type=script&lang=js"

import "./xtx-button.vue?vue&type=style&index=0&id=a4b8c170&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\three_2\\ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4b8c170"]])

export default __exports__